export default __webpack_public_path__ + "static/media/image-068.51de8989.jpeg";